import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const PcBetterFood = ({ clickNext = () => {}, clickPrev = () => {}, clicked, isCurPage, }) => {
  return (
    <div className="better-food-pc" data-model-id="16867:7608">
      <div className="contents">
        <div className="container">
          <div className="image-container">
            <Image src="/static/image/questionnaire/weight-loss/better-food/pc/left-card.png" alt="Left card" className="left-card" />
          </div>

          <div className="text-container">
            <p className="text-wrapper">Learn to make better choices of food</p>

            <a className="description" href={"https://cms-cache.foodscannerai.com/recipe/Calo_Source_of_Recommendation.html"}>Source of recommendations</a>
          </div>
        </div>
      </div>
    </div>
  );
};
